module.exports = __webpack_public_path__ + "static/assets/7fbfc01eac76174cfe97e2581727be04.svg";